export const T_SHIRT_SIZE = [
  {
    value: 'S',
    label: 'Small',
  },
  {
    value: 'M',
    label: 'Medium',
  },
  {
    value: 'L',
    label: 'Large',
  },
  {
    value: 'XL',
    label: 'Extra large',
  },
  {
    value: 'XXL',
    label: 'Extra extra large',
  },
];
